import { useQuery } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import api from '@pray/shared/utils/api';
import storage from '@pray/shared/utils/storage';

import type { ConversationStatsResponse, ConversationStats } from './types';

export interface GetConversationStatsParams {
  artistId: string;
  startDate?: string;
  endDate?: string;
}

export async function getConversationStats({
  artistId,
  startDate,
  endDate,
}: GetConversationStatsParams): Promise<ConversationStats> {
  if (!artistId) throw Error('Artist ID is required');

  const params: Record<string, string> = {};

  if (startDate) {
    params.start_date = startDate;
  }

  if (endDate) {
    params.end_date = endDate;
  }

  const url = `/web/studio/artists/${artistId}/conversations/stats`;
  const response = await api.executeGetRequest<ConversationStatsResponse>(url, params);

  return response.data.data;
}

export function useConversationStats(artistId: string, startDate?: string, endDate?: string) {
  const user = storage.getUser();

  return useQuery({
    queryKey: queryKeys.artistConversationStats(artistId, { startDate, endDate }),
    queryFn: () => getConversationStats({ artistId, startDate, endDate }),
    enabled: !!artistId && !!user?.is_registered,
    staleTime: 60 * 1000, // Consider fresh for 1 minute
  });
}
